import React, { useMemo } from 'react'

import { Grid } from '@material-ui/core'

import { CardRowItemProps } from '../CardRowItem'

export type CardRow = {
  columns?: 3 | 4
  children:
    | React.ReactElement<CardRowItemProps>
    | React.ReactElement<CardRowItemProps>[]
}

const CardRow: React.FC<CardRow> = ({ children, columns = 3 }) => {
  const gridSize = useMemo(() => (columns === 3 ? 4 : 3), [columns])

  const changeElement = (item: React.ReactElement<CardRowItemProps>) =>
    React.cloneElement<CardRowItemProps>(item, { xs: 12, sm: 6, md: gridSize })

  return (
    <Grid container spacing={4}>
      {React.Children.map(children, changeElement)}
    </Grid>
  )
}

export default CardRow
